<div class="modal-body">
  <div class="modal-fluid">
    <div class="section-holder">
      <div class="completed-header"> </div>
      <!-- Project  -->
      <ng-container *ngIf="type === 'project'">
        <h1 class="confirm-labels" id="account-validated"> 
          {{ "common.succesExclamation" | translate}} 
        </h1>
    
        <div class="confirm-caption custom-m-md text-center">
          <p> {{ "projects.team.congrats" | translate }} </p>
        </div>  
  
        <div class="text-center teammate-holders">
          <div class="teammate">
            <!-- <p class="email"> {{ member?.email }} </p>
            <p class="role"> {{ member?.roles }} </p> -->
            <ng-container *ngFor="let member of data; let first = first; let last = last" >
              <p class="email"> 
                {{ member?.email }}<span class="m-r-xs" *ngIf="!last">, </span>
              </p> 
            </ng-container>
          </div>
        </div>
        <div class="confirm-caption custom-m-md text-center m-t-sm">
          <p> 
            Please be aware that users added who were not previously apart of your account will affect your account’s billing.
          </p>
        </div>  
        <div class="buttons-holder">
          <button mat-raised-button
            (click)="goToMembers()"
            color="primary" 
            id="create-another-btn" 
            class="auth-btn m-b-md mat-primary">
            <span class="capitalize"> {{ "common.continue" | translate }} </span>
          </button>
        </div>
      </ng-container>
  
      <!-- Company  -->
      <ng-container *ngIf="type === 'company'">
        <h2 class="confirm-labels" id="account-validated"> 
          {{ "common.succesExclamation" | translate}} 
        </h2>
    
        <div class="confirm-caption custom-m-md text-center">
          <p> {{ "projects.create.created" | translate }} </p>
          <ng-container *ngIf="title">
            <p class="bold"> {{ title }} </p>
          </ng-container>
        </div>  
        
        <ng-container *ngIf="data.length">
          <div class="divider"></div>
          <div class="confirm-caption custom-m-md text-center m-t-sm">
            <p> 
              You have invited the following new team members to your project! Please be aware that team members below who were not previously apart of your account will affect your monthly billing.
            </p>
          </div>  
          <div class="text-center teammate-holders">
            <div class="teammate">
              <ng-container *ngFor="let member of data; let first = first; let last = last" >
                <p class="email"> 
                  {{ member?.email }}<span class="m-r-xs" *ngIf="!last">, </span>
                </p> 
              </ng-container>
            </div>
          </div>
        <div class="divider"></div>
        </ng-container>

        <div class="buttons-holder flex-column">
            <button 
            mat-raised-button 
            color="primary" 
            id="login-btn" 
            class="auth-btn" 
            [autofocus]="false"
            (click)="goToCreateContract()">
            <span class="capitalize"> {{ "contracts.create" | translate }} </span>
          </button>
  
          <button 
            mat-stroked-button 
            (click)="goToDailyLogs()"
            color="primary" 
            id="signup-btn" 
            class="auth-bt m-t-md">
            <span class="capitalize"> {{ "dailyLogs.setUp" | translate }} </span>
          </button>
  
          <button mat-stroked-button
            (click)="goToProjectSettings()"
            color="primary" 
            id="setup-btn" 
            class="auth-btn m-t-md m-b-md">
            <span class="capitalize"> {{ "projects.settings" | translate }} </span>
          </button>
        </div>
      </ng-container>

      <!-- Contract  -->
      <ng-container *ngIf="type === 'contract'">
        <h2 class="confirm-labels" id="account-validated"> 
          {{ "common.succesExclamation" | translate}} 
        </h2>
    
        <ng-container  *ngIf="created">
          <div class="confirm-caption custom-m-md text-center">
            <p> {{ "contracts.join.completed" | translate }} </p>
            <ng-container *ngIf="getTitle">
              <p class="bold"> {{ getTitle }} </p>
            </ng-container>
          </div> 
        </ng-container>

        <ng-container  *ngIf="!created">
          <div class="confirm-caption custom-m-md text-center">
            <p> {{ "projects.team.congrats" | translate }} </p>
          </div> 
        </ng-container>
        
        <ng-container *ngIf="data.length">
          <div class="divider"></div>
          <div class="confirm-caption custom-m-md text-center m-t-sm" *ngIf="created">
            <p> 
              You have invited the following new team members to your project! Please be aware that team members below who were not previously apart of your account will affect your monthly billing.
            </p>
          </div>  

          <div class="text-center teammate-holders">
            <div class="teammate">
              <ng-container *ngFor="let member of data; let first = first; let last = last" >
                <p class="email"> 
                  {{ member?.email }}<span class="m-r-xs" *ngIf="!last">, </span>
                </p> 
              </ng-container>
            </div>
          </div>

          <div class="confirm-caption custom-m-md text-center m-t-sm" *ngIf="!created">
            <p> 
              Please be aware that users added who were not previously apart of your account will affect your account’s billing.
            </p>
          </div>  
          <div class="divider"></div>
        </ng-container>

        <div class="buttons-holder">
          <button mat-raised-button
            (click)="goToMembers()"
            color="primary" 
            id="create-another-btn" 
            class="auth-btn m-b-md mat-primary">
            <span class="capitalize"> {{ "common.continue" | translate }} </span>
          </button>
        </div>
      </ng-container>
    </div>
  </div>
</div>